import size from "../sizes";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `
        <p>Штаны спортивные женские</p>
      `,
      printingInfo: `
        <h3>Прямая цифровая печать</h3>
        <p>
          Рисунок печатается непосредственно на продукт, без промежуточных этапов, вроде нанесения фото на термобумагу. Вы можете напечатать любой дизайн! Цифровая печать позволяет полностью передать палитру красок вашего дизайна. Рисунок, нанесенный таким способом, не ощущается на ощупь.
        </p>
        <h3>Термоплёнка</h3>
        <p>
          Большая палитра флекс-плёнок: светоотражающие, золотистые и другие необычные цвета.
        </p>
        <p>
          Плёнка хорошо подходит для принтов с одним цветом или комбинации двух-трёх цветов без мелких деталей. Может наноситься в сложных местах: рукава, штанины, около швов.
        </p>
      `
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`woman_pants`]
    }
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
